import { RouterView } from 'vue-router';

export const languageRoutes = {
  path: 'language/:id',
  component: () => import('layouts/LanguageLayout.vue'),
  children: [
    {
      name: 'showLanguage',
      path: '',
      redirect: { name: 'showLanguageCourses' },
    },
    // {
    //   name: 'showLanguageDashboard',
    //   path: 'dashboard',
    //   component: () => import('pages/language/Dashboard.vue'),
    // },
    {
      name: 'showLanguageCourses',
      path: 'courses',
      component: () => import('pages/language/CourseListPage.vue'),
    },
    {
      name: 'showLanguageStudentResponses',
      path: 'srti',
      component: () => import('pages/language/StudentResponses.vue'),
    },
    {
      name: 'showLanguageGradeSubmitted',
      path: 'grade_submitted',
      redirect: { name: 'showLanguageGradeSubmittedList' },
      component: RouterView,
      children: [
        {
          path: 'courses',
          name: 'showLanguageGradeSubmittedList',
          redirect: { name: 'showLanguageGradeSubmittedModules' },
          component: () => import('pages/language/GradeSubmittedNav.vue'),
          children: [
            {
              name: 'showLanguageGradeSubmittedModules',
              path: 'modules',
              component: () =>
                import('pages/language/GradeSubmittedModules.vue'),
            },
          ],
        },
        {
          path: 'show/:courseInstanceId',
          name: 'showLanguageGradeSubmittedShow',
          component: () =>
            import('pages/language/GradeSubmittedCourseShow.vue'),
          children: [
            {
              name: 'showLanguageGradeSubmittedShowEnrollment',
              path: 'enrollment/:enrollmentId',
              component: () =>
                import('pages/language/GradeSubmittedEnrollment.vue'),
            },
            {
              name: 'showLanguageGradeSubmittedShowReport',
              path: 'report',
              component: () =>
                import('pages/language/GradeSubmittedReport.vue'),
            },
          ],
        },
      ],
    },
  ],
};
